// Environment Configuration for Perplexity Sonar API
// Make sure to create a .env file with REACT_APP_PERPLEXITY_API_KEY=your_actual_api_key

export const ENV_CONFIG = {
  // Perplexity Sonar API Configuration
  PERPLEXITY_API_KEY: process.env.REACT_APP_PERPLEXITY_API_KEY || 'INSERT_YOUR_API_KEY_HERE',
  PERPLEXITY_BASE_URL: 'https://api.perplexity.ai',

  // Agent Configuration
  MAIN_AGENT_MODEL: 'sonar-pro',
  SPECIALIST_AGENT_MODEL: 'sonar-reasoning-pro',
  RESEARCH_AGENT_MODEL: 'sonar-deep-research',

  // Search Configuration
  DEFAULT_SEARCH_CONTEXT_SIZE: 'medium',
  ENABLE_DOMAIN_FILTERING: true,
  DEFAULT_MAX_TOKENS: 1500,

  // Health Domain Filters
  MEDICAL_DOMAINS: [
    'mayoclinic.org',
    'webmd.com', 
    'healthline.com',
    'cdc.gov',
    'nih.gov',
    'medlineplus.gov'
  ],
  
  NUTRITION_DOMAINS: [
    'nutrition.gov',
    'usda.gov',
    'diabetes.org',
    'heart.org'
  ],
  
  MEDICATION_DOMAINS: [
    'fda.gov',
    'drugs.com',
    'rxlist.com',
    'medscape.com'
  ],

  // Emergency Configuration
  EMERGENCY_DOMAINS: [
    'cdc.gov',
    'redcross.org',
    'fema.gov',
    '911.gov'
  ],
  
  ENABLE_EMERGENCY_MODE: true,

  // Agent Routing Configuration
  ENABLE_AGENT_ROUTING: true,
  MAX_AGENT_HOPS: 3,
  AGENT_CONFIDENCE_THRESHOLD: 0.7
};

// To use this configuration:
// 1. Create a .env file in the project root
// 2. Add: REACT_APP_PERPLEXITY_API_KEY=your_actual_api_key_here
// 3. Restart your development server 